import { render } from "./Work.vue?vue&type=template&id=7c4acfb1&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "@/assets/css/layout.css?vue&type=style&index=0&id=7c4acfb1&scoped=true&lang=css"
import "@/assets/css/work.css?vue&type=style&index=1&id=7c4acfb1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4acfb1"]])

export default __exports__